<template>
    <CustomMenu
        v-model="menu"
        :maxHeight="440"
        :menuWidth="286"
        :fullScreen="isMobView"
        persistent
    >
        <template #activator>
            <div
                class="pr-3 flex items-center"
            >
<!--                cursor-pointer-->
<!--                @click.stop="menuHandler"-->
                <div class="size-6 shrink-0 flex items-center justify-center bg-white-300 dark:bg-purple-680 border border-white-500 dark:border-purple-680 rounded-1.25">
                    <AiIcon14x14 />
                </div>

                <div class="pl-2 pr-1 text-xs font-medium text-gray-370 dark:text-white">
                    {{ currentAgent.name }}
                </div>

<!--                <div class="min-w-5">-->
<!--                    <ArrowChevronBottomIcon-->
<!--                        class="text-gray-200 transition-all"-->
<!--                        :class="{ 'rotate-180': menu }"-->
<!--                    />-->
<!--                </div>-->
            </div>
        </template>

        <template #dropdown>
            <ListDropdown
                v-if="menu"
                v-model:currentItem="currentAgent"
                :menu="menu"
                :items="Object.values(AGENTS)"
                itemValue="url"
                widthBody="w-40 max-mob:w-full"
                returnObject
                mini
                @closeMenu="menuHandler"
            />
        </template>
    </CustomMenu>
</template>

<script setup>
import { ref, computed, inject } from 'vue'

import CustomMenu from '@/components/menu/CustomMenu/CustomMenu.vue'
import AiIcon14x14 from '@/components/icons/AI/AiIcon14x14.vue'
import ArrowChevronBottomIcon from '@/components/icons/arrow/20x20/ArrowChevronBottomIcon.vue'
import ListDropdown from '@/components/menu/dropdown/ListDropdown/ListDropdown.vue'

import { AGENTS } from '@/constants/aiAgents'
import { viewPorts } from '@/constants/viewPorts'

const currentAgent = defineModel('modelValue', { type: Object, default: () => AGENTS.diagnostic })

const menu = ref(false)

const currentViewSize = inject('currentViewSize')

const isMobView = computed(() => viewPorts.mob >= currentViewSize.value)

function menuHandler() {
    menu.value = !menu.value
}
</script>
